module.exports = __webpack_public_path__ + "static/media/auth-login-bg.641e1b23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/auth-login-bg.png
// module id = 1309
// module chunks = 3